import { useEffect, useState } from 'react';
import { useDispatch, useTrackedState } from '../../config/store';

function CandidateResumePDF(interview) {
  const state = useTrackedState();
  const dispatch = useDispatch();
  const [isFetchingPDF, setIsFetchingPDF] = useState(false);

  const fetchCandidateResume = () => {
    if (state.resumePDF?.url && interview?.interviewData.Candidate_Name.id === state.resumePDF?.id) {
      window.open(window.URL.createObjectURL(state.resumePDF.url));
      window.URL.revokeObjectURL(state.resumePDF.url);
    } else if (state.user?.token && interview?.interviewData?.Candidate_Name?.id) {
      setIsFetchingPDF(true);
      dispatch({
        type: 'GET_RESUME_PDF',
        candidateId: interview.interviewData.Candidate_Name.id,
        token: state.user.token,
      });
    }
  };
  // A candidate with no resume answers with a null url instead of an error, so the spinner has to
  // stop on any answer for this candidate — not only on a document. This must be read during
  // render: `useTrackedState` only re-renders on properties touched here, and reading the id
  // inside the effect tracked nothing, so `url` staying null meant no re-render at all.
  const answeredForThisCandidate =
    !!interview?.interviewData?.Candidate_Name?.id && state.resumePDF?.id === interview.interviewData.Candidate_Name.id;

  useEffect(() => {
    if (state.error || answeredForThisCandidate) {
      setIsFetchingPDF(false);
    }
  }, [answeredForThisCandidate, state.error, isFetchingPDF]);

  const openCandidateResume = () => {
    if (state.resumePDF?.url) {
      const pdfUrl = window.URL.createObjectURL(state.resumePDF.url);
      window.open(pdfUrl, '_blank');
      window.URL.revokeObjectURL(state.resumePDF.url);
    }
  };

  return {
    fetchCandidateResume,
    openCandidateResume,
    hasResumePDF: !!state.resumePDF?.url,
    isFetchingPDF,
  };
}

export default CandidateResumePDF;
